// SendMail.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config"; // Adjust if needed
import axios from "axios";
import Swal from "sweetalert2";
import NavBar from "./NavBar";

const SendMail = () => {
  const [users, setUsers] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const fetchedUsers = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(fetchedUsers);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };

    fetchUsers();
  }, []);

const sendEmail = async () => {
  if (!selectedEmail || !subject || !companyName || !htmlContent) {
    Swal.fire("Error", "Please fill in all fields.", "error");
    return;
  }

  const emailTemplate = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: auto; border: 1px solid #e0e0e0; padding: 20px;">
      <!-- Header -->
      <div style="text-align: center; padding-bottom: 20px; border-bottom: 1px solid #ddd;">
         <img src="https://vyntacapitals.com/public/uploads/logo/light.png" alt="${"vyntacapitals"} Logo" style="height: 60px; margin-bottom: 10px;" />
        <h2 style="margin: 0; color: #333;">${"vyntacapitals"}</h2>
      </div>

      <!-- Body -->
      <div style="padding: 20px 0; color: #333;">
        ${htmlContent}
      </div>

      <!-- Footer -->
      <div style="border-top: 1px solid #ddd; padding-top: 15px; font-size: 12px; color: #777; text-align: center;">
        <p>You're receiving this email from ${"vyntacapitals"}</p>
        <p>© ${new Date().getFullYear()} ${"vyntacapitals"}. All rights reserved.</p>
      </div>
    </div>
  `;

  try {
    await axios.post("https://renderbackend-24k2.onrender.com/send-mail", {
        // await axios.post("http://localhost:5000/send-mail", {
      email: selectedEmail,
      subject,
      CompanyName: companyName,
      htmlToSend: emailTemplate,
    });

    Swal.fire("Success", "Email sent successfully!", "success");
    setSubject("");
    setCompanyName("");
    setHtmlContent("");
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Failed to send email.", "error");
  }
};


  return (
    <>
      {/* Top AdminLTE Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      {/* Custom NavBar */}
      <NavBar />

      {/* Main Form Container */}
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "600px" }}>
          <h3 className="text-center mb-4">Send Email to User</h3>

          <div className="form-group mb-3">
            <label>Select User</label>
            <select
              className="form-control"
              value={selectedEmail}
              onChange={(e) => setSelectedEmail(e.target.value)}
            >
              <option value="">-- Select a user --</option>
              {users.map((user) => (
                <option key={user.id} value={user.email}>
                  {user.fullname || user.email}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group mb-3">
            <label>Email Subject</label>
            <input
              type="text"
              className="form-control"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          <div className="form-group mb-3">
            <label>Company Name</label>
            <input
              type="text"
              className="form-control"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label>Email HTML Content</label>
            <textarea
              className="form-control"
              rows="6"
              value={htmlContent}
              onChange={(e) => setHtmlContent(e.target.value)}
            />
          </div>

          <button className="btn btn-primary w-100" onClick={sendEmail}>
            Send Email
          </button>
        </div>
      </div>
    </>
  );
};

export default SendMail;
